"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgMeh = () => (0, jsx_runtime_1.jsxs)("svg", {
  id: "Light_1px_meh",
  "data-name": "Light 1px/meh",
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  children: [(0, jsx_runtime_1.jsx)("rect", {
    id: "Light_1px_meh_background",
    "data-name": "Light 1px/meh background",
    width: "64",
    height: "64",
    fill: "#fff"
  }), (0, jsx_runtime_1.jsxs)("g", {
    id: "Group",
    transform: "translate(5.333 5.333)",
    children: [(0, jsx_runtime_1.jsx)("path", {
      id: "Combined_Shape",
      "data-name": "Combined Shape",
      d: "M26.666,53.333A26.666,26.666,0,1,1,53.333,26.666,26.7,26.7,0,0,1,26.666,53.333Zm0-50.666a24,24,0,1,0,24,24A24.027,24.027,0,0,0,26.666,2.666Z",
      fill: "#1c1c1c"
    }), (0, jsx_runtime_1.jsx)("path", {
      id: "Ellipse_202",
      "data-name": "Ellipse 202",
      d: "M2.667,5.333A2.667,2.667,0,1,1,5.333,2.667,2.667,2.667,0,0,1,2.667,5.333Z",
      transform: "translate(13.333 16)",
      fill: "#1c1c1c"
    }), (0, jsx_runtime_1.jsx)("path", {
      id: "Ellipse_203",
      "data-name": "Ellipse 203",
      d: "M2.667,5.333A2.667,2.667,0,1,1,5.333,2.667,2.667,2.667,0,0,1,2.667,5.333Z",
      transform: "translate(34.667 16)",
      fill: "#1c1c1c"
    }), (0, jsx_runtime_1.jsx)("path", {
      id: "Vector_671_Stroke_",
      "data-name": "Vector 671 (Stroke)",
      d: "M1.333,0H22.667a1.333,1.333,0,0,1,0,2.667H1.333A1.333,1.333,0,0,1,1.333,0Z",
      transform: "translate(14.667 33.333)",
      fill: "#1c1c1c"
    })]
  })]
});
exports.default = SvgMeh;